import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 redirect: legacy WordPress URL -> current canonical page
export const Route = createFileRoute("/ringcentral-partner")({
  beforeLoad: () => {
    throw redirect({ href: "/services/voip", statusCode: 301 });
  },
});
